import { render, staticRenderFns } from "./infoBasic.vue?vue&type=template&id=3a75d710&scoped=true"
import script from "./infoBasic.vue?vue&type=script&lang=js"
export * from "./infoBasic.vue?vue&type=script&lang=js"
import style0 from "./infoBasic.vue?vue&type=style&index=0&id=3a75d710&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a75d710",
  null
  
)

export default component.exports